import { useLang } from "@/context/LanguageContext";
import { MacroDonut, MacroBar } from "@/components/Macros";
import { MEALS } from "@/lib/foodlog";

const pct = (v, t) => (t ? Math.round(((v || 0) / t) * 100) : 0);

export function DaySummary({ day }) {
  const { t } = useLang();
  const tot = day.totals, target = day.target;
  const over = target && tot.calories > target.calories;
  return (
    <div className="chenia-card p-5 sm:p-6" data-testid="journal-summary">
      <div className="grid sm:grid-cols-[auto_1fr] gap-6 items-center">
        <MacroDonut value={tot.calories} max={target?.calories || Math.max(tot.calories, 1)} color={over ? "#A8BBA2" : "#C87D65"}
          label={target ? (over ? `+${Math.round(tot.calories - target.calories)} ${t("kcal")} ${t("j_over")}` : `${t("j_remaining")}: ${day.remaining} ${t("kcal")}`) : `${t("kcal")} ${t("j_consumed")}`}
          sublabel={target ? `/ ${target.calories} ${t("kcal")}` : t("kcal")} />
        <div className="space-y-3.5 min-w-0" data-testid="journal-macros">
          <MacroBar label={t("protein")} value={tot.protein} unit={target ? `g / ${target.protein} g` : " g"} pct={pct(tot.protein, target?.protein)} color="#C87D65" />
          <MacroBar label={t("carbs")} value={tot.carbs} unit={target ? `g / ${target.carbs} g` : " g"} pct={pct(tot.carbs, target?.carbs)} color="#A8BBA2" />
          <MacroBar label={t("fat")} value={tot.fat} unit={target ? `g / ${target.fat} g` : " g"} pct={pct(tot.fat, target?.fat)} color="#E8B4B8" />
        </div>
      </div>
      {day.count === 0 ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="journal-incomplete">{t("j_incomplete")}</p>
      ) : (
        <div className="mt-5" data-testid="journal-by-meal">
          <p className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">{t("j_by_meal")}</p>
          <div className="mt-2 flex h-2.5 rounded-full overflow-hidden bg-secondary">
            {MEALS.map((m, i) => <div key={m} style={{ width: `${tot.calories ? (100 * (day.by_meal[m]?.calories || 0)) / tot.calories : 0}%`, background: ["#C87D65", "#A8BBA2", "#E8B4B8", "#D9C6B0"][i] }} />)}
          </div>
          <div className="mt-2 grid grid-cols-2 sm:grid-cols-4 gap-1 text-xs text-muted-foreground">
            {MEALS.map((m, i) => <span key={m} className="inline-flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: ["#C87D65", "#A8BBA2", "#E8B4B8", "#D9C6B0"][i] }} />{t(`j_${m}`)} · {day.by_meal[m]?.calories || 0}</span>)}
          </div>
        </div>
      )}
    </div>
  );
}
